import Row from '@/components/ezuro/workschedule/components/Row.vue';
import RowEmpty from '@/components/ezuro/workschedule/components/RowEmpty.vue';
import ScheduleTable from '@/components/ezuro/mixins/ScheduleTable.js';

export default {
  name: 'Table',
  props: {
    departmentId: {
      type: Number
    },
    divisionId: {
      type: Number
    },
    filterData: {
      type: Object
    },
    scheduleData: {
      type: Object
    },
    section: {
      type: String
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  mixins: [ScheduleTable],
  components: {
    Row, RowEmpty
  },
  data: function () {
    return {
      hiddenTeams: [],
      isElementReady: false
    }
  },
  computed: {
    weekday_names () {
      return this.$t('general.datestr.weekdays.short');
    },
    schedule () {
      for (const item of this.scheduleData.schedules) {
        if (item.department_id == this.departmentId && item.division_id == this.divisionId) {
          return item;
        }
      }

      return false;
    },
    records () {
      const records = [];

      for (const item of this.scheduleData.records) {
        if (!records[item.user_id]) {
          records[item.user_id] = [];
        }

        if (item.schedule_id === this.schedule.id) {
          records[item.user_id].push(item);
        }
      }

      return records;
    },
    notesByDay () {
      const scheduleId = this.schedule.id;
      const notes = [];
      for (const note of this.scheduleData.notes) {
        if (note.schedule_id == scheduleId) {
          notes[note.day] = note.notes;
        }
      }
      return notes;
    },
    editable () {
      return this.section !== 'list-my';
    },
    layoutSettings () {
      return this.$store.state.hr.ezLayoutSettings;
    },
    mainColumnsCount () {
      return (this.layoutSettings && this.layoutSettings.showTotals) ? 11 : 2;
    }
  },
  methods: {
    editRecord: function (record) {
      this.$emit('editRecord', record);
    },
    addRecord: function (data) {
      this.$emit('editRecord', data);
    },
    filter () {
      this.$emit('filter');
    },
    editNotes: function (sqlDay) {
      this.$emit('editNotes', {
        isTableView: true,
        sqlDay: sqlDay,
        scheduleId: this.schedule.id,
        departmentId: this.departmentId,
        divisionId: this.divisionId
      });
    },
    toggleTeam: function (id) {
      const index = this.hiddenTeams.indexOf(id);

      if (index !== -1) {
        this.hiddenTeams.splice(index, 1);
      } else {
        this.hiddenTeams.push(id);
      }
    }
  },
  watch: {
    teams: {
      immediate: true,
      handler () {
        this.$emit('updateScheduleData', { teams: this.teams, usersByTeam: this.usersByTeam })
      }
    }
  },
  mounted () {
    this.isElementReady = true;
  },
  unmounted () {
    this.isElementReady = false;
  }
}
